<template>
    <v-dialog persistent no-click-animation v-model="show" :title="title" :width="width">
        <div class="TextEditor">
            <!--Header dialog-->
            <div class="dialog-header">
                <div>{{ title | capitalize }}</div>
                <v-btn small icon @click="close">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </div>
            <!--Content dialog-->
            <v-form ref="form" v-model="formValid" @submit="submit">
                <div class="px-10 py-10">
                    <v-autocomplete
                        v-if="type === 'autocomplete'"
                        v-model="text"
                        :items="options"
                        :rules="formRules.required"
                        class="input-custom"
                    ></v-autocomplete>
                    <v-text-field
                        v-else
                        outlined
                        dense
                        :rules="rules"
                        v-model="text"
                        autofocus
                        :counter="maxLength > 0"
                        :maxlength="maxLength > 0 ? maxLength : 1000000"
                        class="input-custom"
                    ></v-text-field>
                </div>
            </v-form>
            <!--Footer dialog-->
            <div class="dialog-footer">
                <div class="btn-primary"
                     @click="submit">{{ $f.tc('save') }}
                </div>
                <div class="btn-outline-secondary ml-8" @click="close">{{ $f.tc('cancel') }}</div>
            </div>
        </div>
    </v-dialog>
</template>

<script>
import DialogPromiseFormMixin from '@/modules/fptai/mixins/DialogPromiseFormMixin'
import FormRules from "@/modules/fptai/utils/FormRules";
import {AppServiceEventBus, AppServiceEventBusType} from "@/eventbus/appservice.eventbus";

export default {
    name: 'TextEditor',
    mixins: [DialogPromiseFormMixin],
    data() {
        return {
            maxLength: 0,
            title: '',
            text: '',
            rules: [],
            width: 500,
            type: 'text', // 'text' or 'autocomplete'
            options: [],
        }
    },
    methods: {
        open(
            {
                type,
                title,
                text,
                rules,
                width,
                maxLength,
                options
            }
        ) {
            this.type = type ? type : 'text'
            this.options = options ? options : []
            this.title = title || this.$f.tc('name')
            this.text = text
            this.width = width || 400
            this.maxLength = maxLength || 0
            this.rules = rules || this.formRules.required
            this.$refs.form.resetValidation()
            this.show = true
            return new Promise((resolve, reject) => {
                this.promise = {
                    resolve,
                    reject
                }
            })
        },
        submitValidForm() {
            this.promise.resolve(this.text)
            AppServiceEventBus.$emit(AppServiceEventBusType.TEXT_EDITOR_DONE, this.text)
            this.close()
        },
        cancel() {
            this.show = false
            this.promise.reject(false)
        }
    }
}
</script>

<style scoped lang="scss">
.TextEditor {
    background: #FFFFFF;
    border-radius: 0 !important;
    overflow: hidden;

    .dialog-header {
        border-bottom: 1px solid #DADFEC;
    }

    .dialog-content {
        padding: 12px;
        max-height: 500px;
        overflow-y: auto;
    }

    .dialog-footer {
        justify-content: center;
        padding: 10px;
        border-top: 1px solid #DADFEC;
    }
}

.input-custom {
    position: relative;
    ::v-deep {
        .v-input__slot {
            height: 36px;
            background: #FFFFFF;
            border-radius: 0;
            border: 1px solid #DADFEC;
            outline: none;
            font-size: 14px;
            padding: 6px 10px 6px 10px;
            margin: 0;
            display: flex;
            align-items: center;

            &:before, &:after {
                border: none !important;
            }
        }
    }
}

::v-deep {
    .v-text-field {
        margin-top: 0 !important;
        padding-top: 0 !important;
    }

    .v-text-field__details {
        position: absolute;
        right: 14px !important;
        top: 11px !important;
    }

    .v-input input {
        height: 36px;
    }
}
</style>
